$(window).on("load",(function(){ 
setTimeout(function() {      
  $(".spr-review").slice(0,2).show();
  	

if($('.p_reviews').html() == "") {
       $(".loadmore").fadeOut("slow");
      }
	  }, 1000);
}));

$(document).ready(function() {
						   
// sticky-bar
$(window).scroll(function() {    
 var scroll = $(window).scrollTop();
  if (scroll >= 100) {
    $('#sticky-bar').addClass('active');		
  } else {
    $('#sticky-bar').removeClass('active');
  }
  
  
// footer show remove sticky bar
$('.footer').each(function (i) {
      var bottom_of_objectf = $(this).offset().top;
      var bottom_of_windowf = $(window).scrollTop() + $(window).height();      
     if (bottom_of_windowf > bottom_of_objectf) {          
		$('#sticky-bar').addClass('no_active');				
      } else {
		$('#sticky-bar').removeClass('no_active');
	  }   
});
});						   
						   
						   

/*
 var speed = 1000,
      $li;  
  $('.media-slider').on('init', function(slick) {
    $(slick.target).find('button').append('<span></span>');    
    $li = $(slick.target).find('.slick-dots li');
    animateSpan(0, $li);
  });

  $('.media-slider').slick({
	  dots: true,
	  infinite: true,
	  arrow:false,
	  speed:550,
	  centerMode: false,
	  slidesToShow:2,
	  slidesToScroll: 1,
	  cssEase: 'ease-in-out',
	  autoplay: false,
	  rtl: true,
	  autoplaySpeed: 1		
  });  
  $('.media-slider').mouseover(function() {
      //  $(this).slick('play')
    });
    $('.media-slider').mouseout(function() {
       // $(this).slick('pause')
    });  
	
	 $('.media-slider').on('wheel', (function(e) {
  e.preventDefault();

  if (e.originalEvent.deltaY < 0) {
    $(this).slick('slickNext');
  } else {
    $(this).slick('slickPrev');
  }
}));
	
	
  $('.media-slider').on('afterChange', function(event, slick, currentSlide, nextSlide) {
    $li.find('button span').stop(true, true);
    $li.find('button').removeClass('filled');    
    if(currentSlide == 0) {
      $li.find('button span').css({
        'transform': 'scaleX(0)',
        'border-spacing': 0
      });
    } else {
      // 
      for(var i = 0; i < currentSlide; i++) {
        $li.eq(i).find('button').addClass('filled');
      }      
      //       
      for(var i = currentSlide + 1; i < $li.length + 1; i++) {
        $li.eq(i - 1).find('button').removeClass('filled')
          .find('span').css({
        'transform': 'scaleX(0)',
        'border-spacing': 0
      });
      }
    }    
    animateSpan(currentSlide, $li);
  });
  
  function animateSpan(currentSlide, $li) {
    var $currentBtn = $li.eq(currentSlide).find('span');    
    $currentBtn.animate({  borderSpacing: 1 }, {
      step: function(now, fx) {
        $(this).css('transform', 'scaleX('+ now +')');  
      },
      duration: speed
    }, 'linear');
  }*/


    const swiper = new Swiper('.swiper', {
      speed: 700,
      loop: true,
      slidesPerView: 2,
      mousewheel: {
        thresholdDelta: 10,
        thresholdTime: 10
      },
      on: {
        init: function () {
          console.log('swiper initialized');
        },
      },
    });
  
  
// Load more Reviews
  $("#loadmore_link").click(function(e){
    e.preventDefault();
    $(".spr-review:hidden").slice(0,2).fadeIn("slow");    
    if($(".spr-review:hidden").length == 0){
       $(".loadmore").fadeOut("slow");
      } 
  });
  
   
  
  if ($(window).width() < 767) {
  $('#related-products #product-grid').slick({
	dots: false,
	infinite: true,
	arrows:false,
	speed: 1000,
	autoplay: false,
	adaptiveHeight: true,
	slidesToShow: 2,
	slidesToScroll: 1 
}); 
  }
  /*
  $('.media-slider').mouseover(function() {
   $(this).addClass('active');  
   setTimeout(function() {    
	$('.media-slider').removeClass('active');  
	}, 1500);
}).mouseout(function(){
   $(this).removeClass('active');  
});*/
  
});

// Product accordion
$('.faq-box h5').on('click', function () {
	$('.faq-box').find('.faq-rte').stop().slideUp();
	$(this).closest('.faq-box').find('.faq-rte').stop().slideToggle();  	
	$('.faq-box h5').not(this).removeClass('active');
	$(this).toggleClass('active');    
});

$('#sticky-bar .product-form__submit + button').on('click', function () {
	$('#BIS_trigger').trigger('click');    
});


// Product info animation

 //window and animation items
  var animation_elements = $.find('.animation-element');
  var web_window = $(window);
  //check to see if any animation containers are currently in view
  function check_if_in_view() {
    //get current window information
    var window_height = web_window.height();
    var window_top_position = web_window.scrollTop();
    var window_bottom_position = window_top_position + window_height - 200;

    //iterate through elements to see if its in view
    $.each(animation_elements, function () {
      //get the element sinformation
      var element = $(this);
      var element_height = $(element).outerHeight();
      var element_top_position = $(element).offset().top;
      var element_bottom_position = element_top_position + element_height + 300;
      //check to see if this current container is visible (its viewable if it exists between the viewable space of the viewport)
      if (element_bottom_position >= window_top_position && element_top_position <= window_bottom_position) {
        element.addClass('in-view');
      } else {
        element.removeClass('in-view');
      }
    });
  }
  //on or scroll, detect elements in view
  $(window).on('scroll resize', function () {
    check_if_in_view();
  });
 

  //trigger our scroll event on initial load
  $(window).trigger('scroll');

 



// Product reviews click smoooth scroll bottom	
$("#rat-link").click(function() {
    $('html, body').animate({ 
        scrollTop: $("#shopify-product-reviews").offset().top - 70
    }, 1000);
});


$(window).on("load resize",(function(){
if ($(window).width() < 767) {
	var blogimg = $("#product-media").height();	      
	$(".product-first-img").css("height", blogimg);
}

  
}));









